export const QUIZ_PRODUCT_TYPES = Object.freeze({
    nutritionMenopause: 'nutrition-menopause',
    nutritionKeto: 'nutrition-keto',
    fitnessPilates: 'fitness-pilates',
    fitnessAsianPilates: 'fitness-asian-pilates',
    nutritionGeneric: 'nutrition-generic',
    fitnessYoga: 'fitness-yoga',
    fitnessYogaMenopause: 'fitness-yoga-menopause',
    fitnessSomaticYoga: 'fitness-somatic-yoga',
    fitnessSomaticExercises: 'fitness-somatic-exercises',
    fitnessWalking: 'fitness-walking',
    fitnessTaichi: 'fitness-taichi',
    nutritionFasting: 'nutrition-fasting',
    nutritionCortisolDetox: 'nutrition-cortisoldetox',
    fitnessCalisthenics: 'fitness-calisthenics',
    fitnessMenWorkout: 'fitness-men-workout',
    fitnessMenWorkoutTaichi: 'fitness-men-workout-taichi',
    fitnessMenChair: 'fitness-men-chair',
    fitnessMenWalking: 'fitness-men-walking',
    fitnessGeneric: 'fitness-generic',
    nutritionMenFasting: 'nutrition-men-fasting',
    nutritionMenGeneric: 'nutrition-men-generic',
});
